import styled from 'styled-components';
import { theme } from '_constants/theme';
import { config } from '_config';
import * as React from 'react';
const { colors, devices, fontSizes, spaces } = theme;

const StyledMonitoringYourTrademarkSection = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 100px;
  padding-bottom: 100px;
  @media ${devices.tablet} {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;
const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  @media ${devices.tablet} {
    flex-direction: column;
    gap: 10px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const StyledLeftPart = styled.div`
  display: flex;
  flex-direction: column;
  color: #7b848d;
  font-size: 16px;
  font-family: 'MontserratBold';
  line-height: 22px;
  ul li {
    font-size: 16px;
    padding-bottom: 16px;
  }
`;
const StyledLeftContainerColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: row;
  align-items: flex-start;
  gap: 30px;
  p {
    color: #7b848d;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.small}px;
    line-height: 20px;
    text-align: left;
  }
  img {
    min-width: 196px;
  }
  @media ${devices.tablet} {
    flex-direction: column;
  }
`;
const StyledRightContainerColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  p {
    color: #7b848d;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.small}px;
    line-height: 20px;
    text-align: left;
  }
  img {
    max-width: 200px;
  }
`;
const StyledSeparator = styled.div`
  background: #dee0e8;
  width: 1px;
`;
const StyledHeader = styled.div`
  color: #f37217;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: ${fontSizes.regular}px;
  width: 100%;
  margin-bottom: 0.5rem;
  @media ${devices.tablet} {
    margin-bottom: 0px;
  }
`;
const StyledHeaderBlue = styled.div`
  color: #f37217;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: ${fontSizes.large4X}px;
  width: 100%;
  margin-bottom: 16px;
  line-height: 30px;
  @media ${devices.tablet} {
    margin-bottom: 0px;
    font-size: ${fontSizes.largeX}px;
  }
`;
const MonitoringYourTrademarkSection = () => {
  return (
    <StyledMonitoringYourTrademarkSection>
      <StyledContainer>
        <StyledLeftContainerColumn>
          <StyledLeftPart>
            <StyledHeaderBlue>Monitoring your trademark:</StyledHeaderBlue>
            <ul>
              <li>Prevents others from using your brand's identity.</li>
              <li>Safeguards your brand's reputation and goodwill.</li>
              <li>Helps you maintain exclusivity in the market.</li>
              <li>How Trademark Monitoring Works</li>
              <li>
                The process of trademark monitoring involves a series of steps
                to ensure the protection of your brand. We leave no stone
                unturned to keep your brand secure.
              </li>
            </ul>
          </StyledLeftPart>
        </StyledLeftContainerColumn>
        <StyledSeparator />
        <StyledLeftContainerColumn>
          <StyledLeftPart>
            <StyledHeaderBlue>The key steps include:</StyledHeaderBlue>
            <ul>
              <li>Identifying potential trademark infringements.</li>
              <li>Evaluating the severity of the infringement.</li>
              <li>Taking legal action to protect your brand's rights.</li>
              <li>Benefits of Trademark Monitoring</li>
              <li>
                The benefits of trademark monitoring extend far beyond legal
                protection. It's a proactive approach to safeguarding your
                brand's reputation and value. Real-life examples of businesses
                saved from potential crises through our services are a testament
                to the value we provide.
              </li>
            </ul>
          </StyledLeftPart>
        </StyledLeftContainerColumn>{' '}
      </StyledContainer>
    </StyledMonitoringYourTrademarkSection>
  );
};

export default MonitoringYourTrademarkSection;
